import { compact, isNaN, uniq } from 'lodash';
import { DateTime } from 'luxon';

export function getNextScheduledDueDate(currentDate: DateTime, dueDates: string[], year: number): DateTime | undefined {
  if (dueDates.length === 0) {
    return undefined;
  }

  for (const dueDateString of dueDates) {
    const dueDate = DateTime.fromFormat(`${dueDateString}/${year}`, 'M/d/yyyy').startOf('day');
    if (dueDate >= currentDate) {
      return dueDate;
    }
  }

  return DateTime.fromFormat(`${dueDates[0]}/${year + 1}`, 'M/d/yyyy').startOf('day');
}

export function getSortedDueDates(dueDates: string[]) {
  return uniq(
    compact(
      dueDates.map((dueDate) => {
        const parts = dueDate.split('/');
        if (parts.length === 2) {
          const month: number = parseInt(parts[0], 10);
          const day: number = parseInt(parts[1], 10);
          if (isNaN(month) || isNaN(day)) {
            return undefined;
          }
          return {
            month: parseInt(parts[0], 10),
            day: parseInt(parts[1], 10),
          };
        }
        return undefined;
      }),
    )
      .sort((a, b) => {
        const monthDiff = a.month - b.month;
        if (monthDiff === 0) {
          return a.day - b.day;
        }
        return monthDiff;
      })
      .map((dueDateParts) => `${dueDateParts.month}/${dueDateParts.day}`),
  );
}
